import React from 'react';
import {Product} from "../components/ProductPage/Product";

export const ProductPage = () => {
  return (
    <>
      <Product/>
    </>
  );
};